import { useQuery } from "@tanstack/react-query";

import { opsAdmin } from "@/api/opsAdmin";
import { Badge, Card, CardBody, EmptyState } from "@/components/ui";

/**
 * Push notifications — delivery audit of recent push sends (web + native).
 * Read-only operator view.
 */
export function AdminPushPage() {
  const list = useQuery({ queryKey: ["push-sends"], queryFn: () => opsAdmin.pushSends() });

  return (
    <div className="space-y-3">
      <h1 className="text-base font-semibold text-term-fg">Push notifications</h1>
      <Card>
        <CardBody className="p-0">
          {list.isLoading ? (
            <div className="p-3 text-sm text-term-mute">Loading…</div>
          ) : !list.data || list.data.length === 0 ? (
            <EmptyState title="No sends" description="Push notification sends appear here as they're dispatched." />
          ) : (
            <table className="w-full text-xs">
              <thead className="bg-term-elev text-term-mute">
                <tr>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">When</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Channel</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Title</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">User</th>
                  <th className="px-3 py-1.5 text-left text-2xs uppercase tracking-wider">Status</th>
                </tr>
              </thead>
              <tbody>
                {list.data.map((p) => (
                  <tr key={p.id} className="border-t border-term-border hover:bg-term-elev">
                    <td className="px-3 py-1.5 tnum text-term-dim whitespace-nowrap">
                      {p.sent_at ? new Date(p.sent_at).toLocaleString() : "—"}
                    </td>
                    <td className="px-3 py-1.5 text-2xs text-term-dim">{p.channel}</td>
                    <td className="px-3 py-1.5 text-term-fg">{p.title}</td>
                    <td className="px-3 py-1.5 font-mono text-2xs text-term-dim">
                      {p.user_id ? p.user_id.slice(0, 8) : "—"}
                    </td>
                    <td className="px-3 py-1.5">
                      <Badge tone={p.status === "sent" || p.status === "delivered" ? "good" : p.status === "failed" ? "bad" : "neutral"}>
                        {p.status}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
